import useSWR from 'swr'
import { useTranslation } from 'react-i18next'
import { paths } from 'routes/paths'
import premieres from 'api/courses/premieres'
import Loader from 'components/ui/loader/Loader'
import { Folder } from '../Folder'

export const Premieres = ({ search }: { search: string }) => {
  const { t } = useTranslation()
  const { data, isLoading } = useSWR(
    { key: 'premieres', search },
    async (arg) =>
      premieres({
        page: 1,
        perPage: 8,
        search: arg.search,
      })
  )

  const courses = data?.courses || []
  return (
    <div>
      {isLoading && <Loader color />}
      {!!courses.length && (
        <Folder
          href={paths.home.premieres}
          name={t('newhome.sections.premiereCourses.title')}
          courses={courses}
          totalCourses={data?.total || 0}
        />
      )}
    </div>
  )
}

export default Premieres
